import { Contatos } from '../models/contatos.model';
import { ENV, URL_CIDADAO_REGISTROS } from '../util/constants';
import { AuthenticateService } from './authenticate.service';
import { Injectable } from '@angular/core';
import { RequestService } from './request.service';

@Injectable({
  providedIn: 'root'
})
export class ContatosService {

  constructor(private http: RequestService, private auth: AuthenticateService) {
  }

  async recuperar() {
    return await this.http.get(`${URL_CIDADAO_REGISTROS}rest/contatoemergencia`,
      null, this.getHeadersToken()).then(result => {
        return result.map(data => new Contatos(data));
      }).catch((error) => {

        if (ENV === 'DEV') {
          return [
            {
              "numeroCartao": null,
              "id": 1870276,
              "nome": "Antenor",
              "telefone": "(66) 66666-6666"
            },
            {
              "numeroCartao": null,
              "id": 1870038,
              "nome": "Maria",
              "telefone": "(88) 88888-8888"
            },
            {
              "numeroCartao": null,
              "id": 1870241,
              "nome": "TESTE 2",
              "telefone": "(11) 11111-1111"
            },
            {
              "numeroCartao": null,
              "id": 2014728,
              "nome": "jljyvb",
              "telefone": "(00) 00000-0000"
            },
            {
              "numeroCartao": null,
              "id": 1046412,
              "nome": "teste",
              "telefone": "(99) 99999-9999"
            }
          ];
        }
        return [];
      });
  }

  async excluir(data) {
    return this.http.delete(`${URL_CIDADAO_REGISTROS}rest/contatoemergencia/${data.id}`,
      null, this.getHeadersToken(), true).then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  async adicionar(prof) {
    return this.http.post(`${URL_CIDADAO_REGISTROS}rest/contatoemergencia`,
      prof, this.getHeadersToken(), true).then(result => {
        return true;
      }).catch((error) => {
        return false;
      });
  }

  getHeaders() {
    return {
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: this.auth.getAuthorizationToken()
    };
  }

  getHeadersToken() {
    const server = JSON.parse(localStorage.getItem('app_icp_token'));
    const token = this.auth.getAuthorizationToken();
    const httpOptions = {
      'Content-Type': 'application/json',
      'X-Authorization-Server': 'Bearer ' + server.access_token,
      'Authorization': 'Bearer ' + token,
    };

    return httpOptions;
  }

  getHeadersJson() {
    return {
      'Content-Type': 'application/json'
    };
  }

}
